import React from 'react';
import { Box, Typography } from '@mui/material';

export const MenuPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Menu Management
      </Typography>
      <Typography variant="body1">
        Menu page content will be implemented here.
      </Typography>
    </Box>
  );
};
